module.exports = __webpack_public_path__ + "img/inbox.1bc75b8d.svg";